import { defaultI18nLang } from '@/plugins/i18n';

export default {
	multiRequired: (v: any) => v[defaultI18nLang] !== '',
	teamResultHaveEntity: (organizations: any[], trainers: any[], athletes: any[]) =>  organizations.length !== 0 || trainers.length !== 0 || athletes.length !== 0,
	hasPosition: (position: string | null, generalInt: any) => {
		return (position != null && position != '') || generalInt != null
	}
};
